module.exports = __webpack_public_path__ + "img/nav-about@2x.147b49f.webp";